<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">{{pageTitle}}</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="dialog__contents">
      <div class="section section--details">
        <div class="section__header header header--mb-15">
          <div class="header__title">
            詳細
          </div>
        </div>
        <div class="section__content">
          <p><span class="bold">作成日</span>: {{createdAt}}</p>
          <p><span class="bold">更新日</span>: {{updatedAt}}</p>
          <p><span class="bold">タイプ</span>: {{ entryType }}</p>
        </div>
      </div>

      <ag-dynamic-form
        [metadata]="studentGPSAcademicMeta"
        [model]="studentGPSAcademicDataModel"
        *ngIf="studentGPSAcademicMeta && studentGPSAcademicDataModel"
      ></ag-dynamic-form>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
  </div>
</div>
